// A browser opens a new window only from inside a tap. The report screens first ask the API for a download
// link and open it after that request, by which time iOS Safari blocks the window without a word — the
// report "would not open". So the window is opened inside the tap and pointed at the link once it is known.
import { Linking, Platform } from 'react-native';

export type PendingWindow = { open: (url: string) => Promise<void>; cancel: () => void };

/** Call synchronously in the press handler, before any await. Null off the web. */
export function openWindowInTap(): PendingWindow | null {
  if (Platform.OS !== 'web') return null;
  const win = window.open('', '_blank');
  return {
    async open(url) {
      if (win && !win.closed) win.location.href = url;
      else await Linking.openURL(url);
    },
    cancel() {
      win?.close();
    },
  };
}
